var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUsdt({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 48,
    viewBox: "0 0 70 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 69,
    height: 47,
    rx: 5.5,
    fill: "white",
    stroke: "#D9D9D9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M51.4876 28.1124C49.2171 37.2196 39.9929 42.7621 30.8846 40.491C21.7801 38.2206 16.2377 28.9958 18.5091 19.8894C20.7786 10.7811 30.0028 5.23823 39.1082 7.5087C48.2159 9.77917 53.758 19.0049 51.4873 28.1125L51.4875 28.1124H51.4876Z",
    fill: "#50AF95"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.1511 25.928C37.0309 25.937 36.4099 25.9741 35.0245 25.9741C33.9226 25.9741 33.1403 25.941 32.8658 25.928C28.6075 25.7407 25.4291 24.9994 25.4291 24.1119C25.4291 23.2244 28.6075 22.4841 32.8658 22.2938V25.1898C33.1443 25.2098 33.9417 25.2569 35.0435 25.2569C36.3658 25.2569 37.0279 25.2018 37.1471 25.1908V22.2958C41.3964 22.4851 44.5678 23.2264 44.5678 24.1119C44.5678 24.9974 41.3974 25.7387 37.1471 25.927L37.1511 25.928ZM37.1511 21.9963V19.4049H43.0813V15.4531H26.9357V19.4049H32.8648V21.9953C28.0456 22.2167 24.4214 23.1713 24.4214 24.3153C24.4214 25.4592 28.0456 26.4129 32.8648 26.6352V34.9394H37.1501V26.6322C41.9584 26.4108 45.5765 25.4572 45.5765 24.3143C45.5765 23.1713 41.9614 22.2177 37.1501 21.9953L37.1511 21.9963Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsdt);
export default __webpack_public_path__ + "static/media/usdt.c3c63d84cfc622390f86bbdd4d9c7115.svg";
export { ForwardRef as ReactComponent };